export default __webpack_public_path__ + "static/media/comp.7c3dc17a.gif";